Base overlay dialog must be extended into a subclass!
